/* Collection and search results behaviour. The template passes its section id as data-sid. */
(function () {
  var sid = document.currentScript ? document.currentScript.getAttribute('data-sid') : '';
  // In-place defaults (spd-collection-body): on a collection page that needs its in-stock-first view,
  // the first run waits for the swap. After it, everything that reads the URL at load reads the
  // parameters the view was rendered for (LOC) while the address bar keeps the clean URL, and the
  // page links it builds are clean too.
  var ip = window.spdInPlace || null;
  if (ip && !ip.applied) return;
  var inPlace = !!(ip && ip.swapped);
  var LOC = inPlace ? new URL(ip.target, location.origin) : location;
  function cleanPage(v) {
    var c = new URL(ip.clean, location.origin);
    if (v > 1) c.searchParams.set('page', String(v)); else c.searchParams.delete('page');
    return c.pathname + c.search;
  }
  var root = document.querySelector(sid ? '.spd-collection--' + sid : '.spd-collection--s');
  if (!root) return;
  var sidebar = root.querySelector('.spd-collection__sidebar');
  var toggle = root.querySelector('[data-spd-filters-toggle]');
  var backdrop = root.querySelector('[data-spd-backdrop]');
  var closeBtn = root.querySelector('[data-spd-filters-close]');
  var narrow = window.matchMedia('(max-width: 989px)');
  var hasPopover = !!(sidebar && typeof sidebar.showPopover === 'function');
  function reflect(open) {
    if (toggle) toggle.setAttribute('aria-expanded', String(open));
    document.documentElement.classList.toggle('spd-drawer-open', open);
    // Everything outside the drawer goes inert while it is open, so focus and screen
    // readers stay inside it. Walks up from the drawer and marks the siblings at each level.
    var node = sidebar;
    while (node && node !== document.body) {
      var parent = node.parentElement;
      if (!parent) break;
      Array.prototype.forEach.call(parent.children, function (el) {
        if (el === node || el === backdrop || el.tagName === 'SCRIPT' || el.tagName === 'STYLE') return;
        el.toggleAttribute('inert', open);
      });
      node = parent;
    }
    if (open && closeBtn) closeBtn.focus({ preventScroll: true });
    else if (!open && toggle) toggle.focus({ preventScroll: true });
  }
  function placeDrawer() { sidebar.style.setProperty('--spd-drawer-top', Math.max(0, window.scrollY) + 'px'); }
  // The sticky sidebar and the phone toolbar sit under the site header, whatever its height is.
  function headerHeight() {
    var wrap = document.querySelector('.site-header-wrapper');
    var section = wrap && wrap.closest('.shopify-section');
    var el = section && getComputedStyle(section).position === 'sticky' ? section : (wrap && getComputedStyle(wrap).position === 'sticky' ? wrap : null);
    document.documentElement.style.setProperty('--spd-header-h', (el ? el.offsetHeight : 0) + 'px');
  }
  headerHeight();
  window.addEventListener('resize', headerHeight);
  window.addEventListener('load', headerHeight);
  // The condition tooltip is position: fixed so the scrolling sidebar cannot clip it; place it by the icon.
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    var el = document.activeElement;
    if (!el) return;
    var tip = el.closest('.spd-badge--tip') || (el.matches('.spd-collection__filter-title') ? el.querySelector('.spd-collection__tip') : null);
    if (!tip) return;
    tip.classList.add('is-dismissed');
    el.addEventListener('blur', function () { tip.classList.remove('is-dismissed'); }, { once: true });
  });
  root.querySelectorAll('.spd-collection__tip').forEach(function (tip) {
    var card = tip.querySelector('.spd-collection__tip-card');
    if (!card) return;
    var place = function () {
      if (narrow.matches) { card.style.left = ''; card.style.top = ''; return; }
      var r = tip.getBoundingClientRect();
      card.style.left = Math.round(r.right + 10) + 'px';
      card.style.top = Math.round(r.top - 14) + 'px';
    };
    tip.addEventListener('mouseenter', place);
    var title = tip.closest('summary');
    if (title) title.addEventListener('focus', place);
  });
  if (sidebar && narrow.matches) {
    sidebar.querySelectorAll('details[data-spd-group]').forEach(function (d) {
      var key = d.getAttribute('data-spd-group') || '';
      d.open = /availability|condition/.test(key) || d.hasAttribute('data-spd-active');
    });
  }
  function isOpen() { return hasPopover ? sidebar.matches(':popover-open') : sidebar.hasAttribute('data-spd-open'); }
  function setDrawer(open) {
    if (!sidebar) return;
    if (hasPopover) {
      if (!narrow.matches) return;
      if (open) placeDrawer();
      try { open ? sidebar.showPopover() : sidebar.hidePopover(); } catch (err) {}
      return; // the toggle event below keeps aria + lock in step, including light dismiss
    }
    if (open) { placeDrawer(); sidebar.setAttribute('data-spd-open', ''); } else sidebar.removeAttribute('data-spd-open');
    if (backdrop) backdrop.hidden = !open;
    reflect(open);
  }
  if (hasPopover) {
    sidebar.addEventListener('toggle', function (e) { reflect(e.newState === 'open'); });
    if (!narrow.matches) { try { sidebar.hidePopover(); } catch (err) {} }
  } else if (sidebar) {
    sidebar.removeAttribute('popover');
  }
  if (toggle) toggle.addEventListener('click', function () { setDrawer(!isOpen()); });
  if (closeBtn) closeBtn.addEventListener('click', function () { setDrawer(false); });
  if (backdrop) backdrop.addEventListener('click', function () { setDrawer(false); });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !hasPopover && isOpen()) setDrawer(false); });
  narrow.addEventListener('change', function (e) { if (!e.matches && isOpen()) setDrawer(false); });
  // Merge filter values. The rows come from the Filter merges page in SPD Toolkit,
  // which its storefront embed prints at the end of the body, so this waits for the parse.
  function runMerges() {
    var cfgEl = document.querySelector('script[data-spd-filter-merges]');
    if (!cfgEl) return;
    var cfg = null;
    try { cfg = JSON.parse(cfgEl.textContent); } catch (err) { return; }
    var lines = String(cfg.rules || '').split(/\n/);
    var mergeSpacing = cfg.ignoreSpacing !== false;
    var map = {};
    lines.forEach(function (line) {
      var i = line.indexOf(':'); if (i < 1) return;
      var target = line.slice(0, i).trim();
      line.slice(i + 1).split(',').forEach(function (v) { v = v.trim(); if (v) map[v.toLowerCase()] = target; });
      map[target.toLowerCase()] = target;
    });
    function keyFor(label) {
      var t = map[label.toLowerCase()];
      if (t) return { key: 'm:' + t.toLowerCase(), label: t };
      if (mergeSpacing) return { key: 's:' + label.replace(/\s+/g, ''), label: label.replace(/\s+/g, '') };
      return { key: 'v:' + label, label: label };
    }
    root.querySelectorAll('details[data-spd-group]').forEach(function (group) {
      var buckets = {};
      group.querySelectorAll('.spd-collection__filter-item').forEach(function (li) {
        var input = li.querySelector('.spd-collection__filter-check');
        var text = li.querySelector('.spd-collection__filter-text');
        if (!input || !text) return;
        var k = keyFor(text.textContent.trim());
        (buckets[k.key] = buckets[k.key] || { label: k.label, items: [] }).items.push({ li: li, input: input, text: text, num: li.querySelector('.spd-collection__filter-num') });
      });
      Object.keys(buckets).forEach(function (k) {
        var b = buckets[k];
        if (b.items.length < 2) {
          // A lone OEM value still shows under the brand it belongs to.
          if (b.items.length === 1 && k.indexOf('m:') === 0) b.items[0].text.textContent = b.label;
          return;
        }
        var keep = b.items.filter(function (it) { return it.text.textContent.trim() === b.label; })[0] || b.items[0];
        var others = b.items.filter(function (it) { return it !== keep; });
        var total = 0, anyChecked = false, allDisabled = true;
        b.items.forEach(function (it) { total += parseInt(it.num ? it.num.textContent : '0', 10) || 0; if (it.input.checked) anyChecked = true; if (!it.input.disabled) allDisabled = false; });
        keep.text.textContent = b.label;
        if (keep.num) keep.num.textContent = String(total);
        keep.input.checked = anyChecked;
        keep.input.disabled = allDisabled;
        keep.li.classList.toggle('spd-collection__filter-item--off', allDisabled);
        others.forEach(function (it) { it.li.hidden = true; it.input.disabled = false; });
        keep.input.addEventListener('change', function () {
          others.forEach(function (it) { it.input.checked = keep.input.checked; });
        });
        // The active pills for a merged row become one pill that removes every value at once.
        var pillBox = root.querySelector('.spd-collection__pills');
        if (pillBox && anyChecked) {
          var names = b.items.map(function (it) { return it.text.textContent.trim(); }).concat([b.label]);
          var pills = Array.from(pillBox.querySelectorAll('.spd-collection__pill')).filter(function (a) {
            var label = a.textContent.replace(/\u00d7\s*$/, '').trim();
            return names.indexOf(label) !== -1;
          });
          if (pills.length > 1) {
            var u = new URL(LOC.href);
            var values = b.items.map(function (it) { return it.input.value; });
            var kept = Array.from(u.searchParams.entries()).filter(function (pr) { return !(pr[0] === keep.input.name && values.indexOf(pr[1]) !== -1); });
            var target = new URL(location.pathname, location.href);
            kept.forEach(function (pr) { if (pr[0] !== 'page') target.searchParams.append(pr[0], pr[1]); });
            pills[0].href = target.pathname + target.search;
            pills[0].firstChild.nodeValue = b.label + ' ';
            pills.slice(1).forEach(function (a) { a.remove(); });
          }
        }
      });
    });
  }
  // A brand search turned into the Brand filter shows as one pill named after the search;
  // its x removes every auto value at once and keeps spdb so the defaults leave it off.
  function collapseAutoBrand() {
    var params = new URLSearchParams(LOC.search);
    if (params.get('spdb') !== '1') return;
    var auto = window.spdBrandAuto || [];
    var pills = Array.from(root.querySelectorAll('.spd-collection__pill[data-spd-pill-param="filter.p.m.filters.brand"]')).filter(function (a) {
      return auto.indexOf(a.getAttribute('data-spd-pill-value')) !== -1;
    });
    if (!pills.length) return;
    var q = (params.get('q') || '').replace(/"/g, '').trim();
    var label = q.replace(/\b\w/g, function (c) { return c.toUpperCase(); });
    var target = new URL(location.pathname, location.href);
    Array.from(params.entries()).forEach(function (pr) {
      if (pr[0] === 'page') return;
      if (pr[0] === 'filter.p.m.filters.brand' && auto.indexOf(pr[1]) !== -1) return;
      target.searchParams.append(pr[0], pr[1]);
    });
    pills[0].href = target.pathname + target.search;
    pills[0].firstChild.nodeValue = label + ' ';
    pills.slice(1).forEach(function (a) { a.remove(); });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', collapseAutoBrand); else collapseAutoBrand();
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', runMerges); else runMerges();
  var form = root.querySelector('[data-spd-filter-form]');
  // A capacity band ticks every capacity inside it, then the form submits as usual.
  if (form) {
    form.addEventListener('change', function (e) {
      var g = e.target;
      if (!g.matches('.spd-collection__filter-check--group')) return;
      var param = g.getAttribute('data-spd-group-param');
      g.getAttribute('data-spd-group-values').split('|').forEach(function (v) {
        var box = form.querySelector('input[name="' + param + '"][value="' + v.replace(/"/g, '\\"') + '"]');
        if (box) box.checked = g.checked;
      });
    }, true);
  }
  if (form) {
    form.addEventListener('change', function (e) {
      if (e.target.matches('.spd-collection__filter-check')) form.submit();
    });
  }
  // The banner text is clamped to 2 lines. The toggle appears only when there is more.
  var heroText = root.querySelector('.spd-collection__hero-copy .spd-collection__hero-text');
  var heroMore = root.querySelector('.spd-collection__hero-more');
  if (heroText && heroMore) {
    var fitHero = function () {
      if (heroText.classList.contains('is-open')) return;
      heroMore.hidden = heroText.scrollHeight <= heroText.clientHeight + 2;
    };
    fitHero();
    window.addEventListener('resize', fitHero);
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(fitHero);
    var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    heroMore.addEventListener('click', function () {
      // Grow or shrink the text over a short transition instead of jumping the page around.
      var open = !heroText.classList.contains('is-open');
      var from = heroText.offsetHeight;
      heroText.classList.toggle('is-open', open);
      var to = heroText.offsetHeight;
      heroMore.setAttribute('aria-expanded', String(open));
      heroMore.textContent = open ? 'Read less' : 'Read more';
      if (reduceMotion || !heroText.animate || from === to) return;
      if (!open) heroText.classList.add('is-open');
      heroText.style.overflow = 'hidden';
      var anim = heroText.animate([{ height: from + 'px' }, { height: to + 'px' }], { duration: 320, easing: 'ease' });
      anim.onfinish = function () {
        heroText.style.overflow = '';
        if (!open) heroText.classList.remove('is-open');
      };
    });
  }
  // A brand search turned into the Brand filter (spdb): the filter form carries the marker so
  // unticking that brand is not undone by the search defaults.
  (function () {
    var form = root.querySelector('[data-spd-filter-form]');
    if (!form) return;
    ['spdb', 'unlisted'].forEach(function (name) {
      if (!new RegExp('[?&]' + name + '=1(&|$)').test(LOC.search) || form.querySelector('input[name="' + name + '"]')) return;
      var h = document.createElement('input');
      h.type = 'hidden'; h.name = name; h.value = '1';
      form.appendChild(h);
    });
  })();
  var sort = root.querySelector('[data-spd-sort]');
  function goSort(value) {
    var url = new URL(window.location.href);
    url.searchParams.set('sort_by', value);
    // A new order starts at its first page, and the in-stock-first run starts in stock.
    url.searchParams.delete('page');
    if (url.searchParams.get('stock') === 'first') url.searchParams.set('filter.v.availability', '1');
    window.location.href = url.toString();
  }
  // A closed select fires change on every arrow key in Chrome and Safari. With the mouse the
  // page changes at once; with the keyboard it waits for Enter or for focus to leave, so the
  // other options can be read first.
  function sortSelect(sel, onPick) {
    var byKey = false, pending = false;
    sel.addEventListener('pointerdown', function () { byKey = false; });
    sel.addEventListener('keydown', function (e) {
      byKey = true;
      if (e.key === 'Enter' && pending) { pending = false; onPick(sel.value); }
    });
    sel.addEventListener('change', function () { if (byKey) { pending = true; return; } onPick(sel.value); });
    sel.addEventListener('blur', function () { if (pending) { pending = false; onPick(sel.value); } });
  }
  if (sort) sortSelect(sort, goSort);
  var products = root.querySelector('[data-spd-products]');
  // Price per TB sort. Shopify cannot sort by it, so every page of the current result set
  // is fetched through the section rendering API, the cards are ordered here and pagination
  // happens in the browser. The same idea Boost used.
  var pptMode = /^ppt-(asc|desc)$/.exec(new URLSearchParams(LOC.search).get('sort_by') || '');
  var pptUnit = (sort && sort.getAttribute('data-spd-ppt-unit')) || 'TB';
  if (pptMode && products && sort) {
    sort.value = 'ppt-' + pptMode[1];
    (function () {
      // Gathers from page 1 of the result set whatever page the shopper is on. With the
      // in-stock-first order that is the in-stock run, then the sold-out run, each sorted on its
      // own and joined in that order. A product with in-stock and sold-out variants comes back
      // in both runs, so cards are kept once by product id. Failed pages are retried, then
      // reported on the page instead of passing a partial list off as complete.
      var pageCap = 30;
      var perPage = parseInt(products.getAttribute('data-spd-per-page'), 10) || 24;
      var sectionId = products.getAttribute('data-spd-section');
      var pagefoot = root.querySelector('.spd-collection__pagefoot');
      var count = root.querySelector('.spd-collection__count');
      var here = new URL(LOC.href);
      // Only the first page of a run is already rendered in the browser; a deeper page is not reusable.
      var domIsFirstPage = !here.searchParams.has('page') || here.searchParams.get('page') === '1';
      if (here.searchParams.has('page')) { here.searchParams.delete('page'); if (!inPlace) history.replaceState(null, '', here.pathname + here.search); }
      var base = new URL(here.href);
      base.searchParams.delete('sort_by');
      base.searchParams.set('section_id', sectionId);
      var stockFirstRun = base.searchParams.get('stock') === 'first';
      var soldOutCount = parseInt(root.getAttribute('data-spd-out'), 10) || 0;
      // Nothing sold out means there is no second run to fetch at all.
      var runs = stockFirstRun ? (soldOutCount > 0 ? ['1', '0'] : ['1']) : [null];
      // The page already in the browser is page 1 of the run it belongs to, so it is not fetched again.
      var currentRun = stockFirstRun ? (here.searchParams.get('filter.v.availability') || '1') : null;
      var domCards = Array.prototype.slice.call(products.querySelectorAll('.spd-card'));
      var domPages = parseInt(products.getAttribute('data-spd-pages'), 10) || 1;
      products.setAttribute('aria-busy', 'true');
      var progress = function (done, total) {
        if (count) count.textContent = 'Sorting by price per ' + pptUnit + '\u2026' + (total > 1 ? ' page ' + Math.min(done, total) + ' of ' + total : '');
      };
      progress(0, 0);
      var budget = pageCap, capped = false, failed = 0, fetched = 0, expected = 0;
      function pageUrl(run, n) {
        var u = new URL(base.href);
        if (run !== null) u.searchParams.set('filter.v.availability', run);
        if (n > 1) u.searchParams.set('page', String(n));
        return u.href;
      }
      function get(url, tries) {
        return fetch(url, { credentials: 'same-origin' }).then(function (r) {
          if (r.ok) return r.text();
          throw new Error(String(r.status));
        }).catch(function () {
          if (tries > 1) return new Promise(function (res) { setTimeout(res, 1200); }).then(function () { return get(url, tries - 1); });
          failed++;
          return null;
        });
      }
      function cardsOf(html) {
        if (!html) return [];
        var doc = new DOMParser().parseFromString(html, 'text/html');
        return Array.prototype.map.call(doc.querySelectorAll('[data-spd-products] > .spd-card'), function (c) { return document.importNode(c, true); });
      }
      function pagesOf(html) {
        var m = /data-spd-pages="(\d+)"/.exec(html || '') || /Page \d+ of (\d+)/.exec(html || '');
        return m ? parseInt(m[1], 10) || 0 : 0;
      }
      // Six requests at a time: fast enough to feel like a sort, bounded so a 30-page gather
      // does not hammer the storefront.
      var LANES = 6;
      function gatherRun(run) {
        if (budget <= 0) { capped = true; return Promise.resolve([]); }
        var mine = domIsFirstPage && run !== null && run === currentRun;
        var firstPromise;
        if (mine) { firstPromise = Promise.resolve(null); }
        else { budget--; firstPromise = get(pageUrl(run, 1), 3); }
        return firstPromise.then(function (first) {
          var pages = mine ? domPages : pagesOf(first), want = [];
          for (var n = 2; n <= pages; n++) { if (budget > 0) { budget--; want.push(n); } else { capped = true; break; } }
          expected += want.length + 1;
          var got = [mine ? domCards : cardsOf(first)];
          progress(++fetched, expected);
          var i = 0;
          function worker() {
            if (i >= want.length) return Promise.resolve();
            var slot = i++, n = want[slot];
            return get(pageUrl(run, n), 3).then(function (html) {
              got[slot + 1] = cardsOf(html); progress(++fetched, expected); return worker();
            });
          }
          var lanes = [];
          for (var w = 0; w < LANES; w++) lanes.push(worker());
          return Promise.all(lanes).then(function () { return [].concat.apply([], got.filter(Boolean)); });
        });
      }
      var dir = pptMode[1] === 'asc' ? 1 : -1;
      function byPpt(a, b) {
        var x = parseInt(a.getAttribute('data-ppt'), 10) || 0, y = parseInt(b.getAttribute('data-ppt'), 10) || 0;
        if (!x && !y) return 0;
        if (!x) return 1;
        if (!y) return -1;
        return (x - y) * dir;
      }
      runs.reduce(function (chain, run) {
        return chain.then(function (all) { return gatherRun(run).then(function (c) { all.push(c.sort(byPpt)); return all; }); });
      }, Promise.resolve([])).then(function (sortedRuns) {
        var seen = {}, cards = [];
        sortedRuns.forEach(function (list) {
          list.forEach(function (c) {
            var id = c.getAttribute('data-spd-product');
            if (id) { if (seen[id]) return; seen[id] = true; }
            cards.push(c);
          });
        });
        if (!cards.length && failed) {
          products.removeAttribute('aria-busy');
          if (count) count.textContent = 'Price per ' + pptUnit + ' sorting could not load. Reload the page to try again.';
          return;
        }
        var page = 1, total = cards.length, last = Math.max(1, Math.ceil(total / perPage));
        function show(n) {
          page = Math.min(Math.max(1, n), last);
          products.innerHTML = '';
          cards.slice((page - 1) * perPage, page * perPage).forEach(function (c) { products.appendChild(c); });
          if (count) count.textContent = Math.min(perPage, total - (page - 1) * perPage) + ' of ' + total + ' drives';
          if (pagefoot) {
            var note = capped ? ' \u00b7 first ' + total + ' results, add a filter to narrow' : '';
            if (failed) note += ' \u00b7 ' + failed + (failed === 1 ? ' page' : ' pages') + ' could not load, reload to try again';
            pagefoot.innerHTML = '<span class="spd-collection__pageinfo">Page ' + page + ' of ' + last + ' \u00b7 sorted by price per ' + pptUnit + note + '</span>' +
              (last > 1 ? '<nav class="spd-collection__pagination" aria-label="Pagination"><button type="button" class="spd-collection__page spd-collection__page--wide" data-ppt-prev aria-label="Previous page"' + (page === 1 ? ' disabled' : '') + '><span class="spd-collection__page-word">Prev</span></button><button type="button" class="spd-collection__page spd-collection__page--wide" data-ppt-next aria-label="Next page"' + (page === last ? ' disabled' : '') + '><span class="spd-collection__page-word">Next</span></button></nav>' : '');
            var prev = pagefoot.querySelector('[data-ppt-prev]'), next = pagefoot.querySelector('[data-ppt-next]');
            if (prev) prev.addEventListener('click', function () { show(page - 1); products.scrollIntoView({ block: 'start' }); });
            if (next) next.addEventListener('click', function () { show(page + 1); products.scrollIntoView({ block: 'start' }); });
          }
        }
        products.removeAttribute('aria-busy');
        if (typeof saLoadScript === 'function') saLoadScript('https://www.shopperapproved.com/widgets/group2.0/14222.js?v=3');
        show(1);
      });
    })();
  }
  // Add to cart on a card stays on the page and opens the cart drawer, the same
  // hand-off the quick shop uses. Anything unexpected falls back to the plain submit.
  // Capture phase: Shopify's own listener sits on the form and counts any submit that is not yet
  // prevented as an add to cart, on top of the one it counts for the fetch below.
  if (products) {
    products.addEventListener('submit', function (e) {
      var form = e.target;
      if (!form.matches || !form.matches('.spd-card__form') || !window.fetch) return;
      e.preventDefault();
      var btn = form.querySelector('button[type="submit"]');
      var label = btn ? btn.textContent : '';
      if (btn) { btn.disabled = true; btn.textContent = 'Adding\u2026'; }
      fetch('/cart/add.js', { method: 'POST', headers: { 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' }, body: new FormData(form) })
        .then(function (r) { if (!r.ok) throw new Error('add failed'); return r.json(); })
        .then(function () {
          if (btn) { btn.textContent = 'Added'; setTimeout(function () { btn.disabled = false; btn.textContent = label; }, 1500); }
          if (window.CustomCartDrawer && typeof window.CustomCartDrawer.open === 'function') window.CustomCartDrawer.open();
          document.dispatchEvent(new CustomEvent('cart:updated'));
          document.dispatchEvent(new CustomEvent('product:added'));
        })
        .catch(function () {
          if (btn) { btn.disabled = false; btn.textContent = label; }
          form.submit();
        });
    }, true);
  }
  // The hover image is fetched the first time a card is hovered or focused, never on load.
  if (products) {
    var loadAlt = function (e) {
      var card = e.target && e.target.closest ? e.target.closest('.spd-card') : null;
      if (!card) return;
      var img = card.querySelector('.spd-card__img--alt[data-src]');
      if (!img) return;
      img.addEventListener('load', function () { card.classList.add('spd-card--alt-ready'); }, { once: true });
      img.srcset = img.getAttribute('data-srcset') || '';
      img.src = img.getAttribute('data-src');
      img.removeAttribute('data-src');
      img.removeAttribute('data-srcset');
    };
    products.addEventListener('mouseover', loadAlt);
    products.addEventListener('focusin', loadAlt);
  }
  // Shopify only lists active filter values it knows about. A value nothing has, like a
  // capacity no product carries, would be invisible and stuck, so any filter in the URL
  // without a pill gets one here.
  (function () {
    var pills = root.querySelector('.spd-collection__pills');
    if (!pills) return;
    // The stock marker and the preview bar flag are not filters, so they stay out of the comparison.
    // In the default in-stock-first order the availability value is the theme's, not a filter, so it gets no pill.
    var stockFirst = /[?&]stock=first(&|$)/.test(LOC.search);
    var skip = function (p) { return p[0] === 'page' || p[0] === 'pb' || p[0] === 'stock' || p[0] === 'spdb' || p[0] === 'unlisted' || p[0] === 'filter.p.m.filters.listed' || (stockFirst && p[0] === 'filter.v.availability') || p[1] === ''; };
    var current = Array.from(new URLSearchParams(LOC.search).entries()).filter(function (p) { return !skip(p); });
    function key(list) { return list.filter(function (p) { return !skip(p); }).map(function (p) { return p[0] + '=' + p[1]; }).sort().join('&'); }
    var have = {};
    pills.querySelectorAll('a[href]').forEach(function (a) {
      try { have[key(Array.from(new URL(a.getAttribute('href'), location.href).searchParams.entries()))] = true; } catch (err) {}
    });
    current.forEach(function (pair, i) {
      if (pair[0].indexOf('filter.') !== 0 || pair[1] === '' || /\.(gte|lte)$/.test(pair[0])) return;
      var rest = current.filter(function (p, k) { return k !== i; });
      if (have[key(rest)]) return;
      var u = new URL(location.pathname, location.href);
      rest.forEach(function (p) { u.searchParams.append(p[0], p[1]); });
      var a = document.createElement('a');
      a.className = 'spd-collection__pill';
      a.href = u.pathname + u.search;
      a.appendChild(document.createTextNode((pair[0] === 'filter.v.availability' ? 'In stock' : pair[1]) + ' '));
      var x = document.createElement('span');
      x.className = 'spd-collection__pill-x';
      x.setAttribute('aria-hidden', 'true');
      x.textContent = '\u00d7';
      a.appendChild(x);
      pills.appendChild(a);
    });
  })();
  // A ticked capacity band shows as one pill that removes every capacity in it.
  (function () {
    var pillBox = root.querySelector('.spd-collection__pills');
    if (!pillBox) return;
    root.querySelectorAll('.spd-collection__filter-check--group:checked').forEach(function (g) {
      var param = g.getAttribute('data-spd-group-param');
      var values = g.getAttribute('data-spd-group-values').split('|');
      var pills = Array.from(pillBox.querySelectorAll('.spd-collection__pill')).filter(function (a) {
        return values.indexOf(a.textContent.replace(/\u00d7\s*$/, '').trim()) !== -1;
      });
      if (!pills.length) return;
      var target = new URL(location.pathname, location.href);
      Array.from(new URLSearchParams(LOC.search).entries()).forEach(function (pr) {
        if (pr[0] === 'page') return;
        if (pr[0] === param && values.indexOf(pr[1]) !== -1) return;
        target.searchParams.append(pr[0], pr[1]);
      });
      pills[0].href = target.pathname + target.search;
      pills[0].firstChild.nodeValue = g.getAttribute('data-spd-group-label') + ' ';
      pills.slice(1).forEach(function (a) { a.remove(); });
    });
  })();
  // In-stock first. The URL carries stock=first: the availability filter is the default order,
  // not a shopper's choice, so its pill and checkbox read as unset, and the in-stock pages
  // continue straight into the sold-out pages as one numbered sequence.
  var virtualPageUrl = null, virtualLast = 0;
  (function () {
    var params = new URLSearchParams(LOC.search);
    if (params.get('stock') !== 'first') return;
    if (root.hasAttribute('data-spd-empty-alone')) {
      // Nothing in stock and nothing sold out: an empty search, not a filter result.
      root.classList.add('spd-collection--empty');
      var ef = root.querySelector('[data-spd-empty-filters]'), ep = root.querySelector('[data-spd-empty-plain]');
      if (ef) ef.setAttribute('hidden', '');
      if (ep) ep.removeAttribute('hidden');
    }
    if (!products) return;
    root.classList.add('spd-collection--stock-first');
    var boxes = Array.prototype.slice.call(root.querySelectorAll('input.spd-collection__filter-check[name="filter.v.availability"]'));
    boxes.forEach(function (i) { i.checked = false; });
    var others = Array.from(params.keys()).filter(function (k) { return k.indexOf('filter.') === 0 && k !== 'filter.v.availability' && k !== 'filter.p.m.filters.listed'; });
    var uniq = others.filter(function (k, i) { return others.indexOf(k) === i; }).length;
    root.querySelectorAll('.spd-collection__filters-num, .spd-collection__filters-n').forEach(function (n) { if (uniq) n.textContent = '(' + uniq + ')'; else n.remove(); });
    if (!uniq) root.querySelectorAll('.spd-collection__filters-clear, .spd-collection__clear-mobile').forEach(function (a) { a.remove(); });
    var countOf = function (v) {
      var i = boxes.filter(function (b) { return b.value === v; })[0];
      var n = i && i.parentElement.querySelector('.spd-collection__filter-num');
      var txt = n ? n.textContent : '0';
      return { n: parseInt(txt.replace(/[^\d]/g, ''), 10) || 0, capped: /\+/.test(txt) };
    };
    var inC = countOf('1'), outC = countOf('0');
    // Shopify's own page links keep the filters but not the stock marker; put it back so page 2
    // of a collection with nothing sold out still reads as the default order, not a filter.
    root.querySelectorAll('.spd-collection__pagination a[href]').forEach(function (a) {
      var u = new URL(a.getAttribute('href'), location.origin);
      // With the address bar on the clean URL, the in-stock page links are clean too (?page=N). Sold-out
      // run links only exist when there is a second run, and render() below rebuilds those.
      if (inPlace && u.searchParams.get('filter.v.availability') !== '0') { a.setAttribute('href', cleanPage(parseInt(u.searchParams.get('page') || '1', 10) || 1)); return; }
      if (!u.searchParams.has('stock')) { u.searchParams.set('stock', 'first'); a.setAttribute('href', u.pathname + u.search); }
    });
    if (!outC.n) return;
    var perPage = parseInt(products.getAttribute('data-spd-per-page'), 10) || 24;
    var serverPages = parseInt(products.getAttribute('data-spd-pages'), 10) || 1;
    var onSoldOut = params.get('filter.v.availability') === '0';
    var pIn = onSoldOut ? Math.ceil(inC.n / perPage) : serverPages;
    var pOut = onSoldOut ? serverPages : Math.ceil(outC.n / perPage);
    var serverPage = parseInt(params.get('page') || '1', 10) || 1;
    var current, last;
    var settle = function () { current = (onSoldOut ? pIn : 0) + serverPage; last = pIn + pOut; virtualLast = last; };
    settle();
    // Shopify caps filter counts at 1,000, so the other group's page count is only an
    // estimate then. One section fetch of that group's first page gives the real number,
    // kept for the session so it costs one request per collection and filter set.
    var otherCapped = onSoldOut ? inC.capped : outC.capped;
    var exactOther = null;
    if (otherCapped) {
      var key = 'spd_pages:' + location.pathname + ':' + (onSoldOut ? '1' : '0') + ':' + Array.from(params.entries()).filter(function (pr) { return pr[0].indexOf('filter.') === 0 && pr[0] !== 'filter.v.availability'; }).map(function (pr) { return pr.join('='); }).sort().join('&');
      try { exactOther = parseInt(sessionStorage.getItem(key), 10) || null; } catch (e) {}
      if (!exactOther) {
        var probe = new URL(LOC.href);
        probe.searchParams.set('filter.v.availability', onSoldOut ? '1' : '0');
        probe.searchParams.delete('page');
        probe.searchParams.set('section_id', products.getAttribute('data-spd-section'));
        fetch(probe.href, { credentials: 'same-origin' }).then(function (r) { return r.ok ? r.text() : ''; }).then(function (html) {
          var m = /data-spd-pages="(\d+)"/.exec(html || '');
          if (!m) return;
          try { sessionStorage.setItem(key, m[1]); } catch (e) {}
          if (onSoldOut) pIn = parseInt(m[1], 10) || pIn; else pOut = parseInt(m[1], 10) || pOut;
          settle();
          render();
        }).catch(function () {});
      } else if (onSoldOut) { pIn = exactOther; settle(); } else { pOut = exactOther; settle(); }
    }
    virtualPageUrl = function (v) {
      if (inPlace) return cleanPage(v);
      var u = new URL(location.href);
      if (v <= pIn) { u.searchParams.set('filter.v.availability', '1'); u.searchParams.set('page', String(v)); }
      else { u.searchParams.set('filter.v.availability', '0'); u.searchParams.set('page', String(v - pIn)); }
      if (u.searchParams.get('page') === '1') u.searchParams.delete('page');
      return u.pathname + u.search;
    };
    var shown = products.querySelectorAll('.spd-card').length;
    var totalText = (inC.capped || outC.capped) ? '1,000+' : (inC.n + outC.n).toLocaleString('en-US');
    var count = root.querySelector('.spd-collection__count');
    // Same rule as the server side: a short page part way through the sequence means the total does
    // not describe what is on screen, so say what is on screen instead.
    var countText = function () {
      var total = (inC.capped || outC.capped) ? Infinity : inC.n + outC.n;
      var floor = (current - 1) * perPage + shown;
      var unreliable = (shown < perPage && current < last) || total < floor;
      return unreliable
        ? shown + (shown === 1 ? ' drive' : ' drives') + ' on this page'
        : shown + ' of ' + totalText + ' drives';
    };
    if (count) count.textContent = countText();
    if (/^ppt-/.test(params.get('sort_by') || '')) return;
    var render = function () {
    var info = root.querySelector('.spd-collection__pageinfo');
    if (info) info.textContent = 'Page ' + current + ' of ' + last + ' \u00b7 showing ' + countText() + ' \u00b7 in stock first';
    if (count) count.textContent = countText();
    var foot = root.querySelector('.spd-collection__pagefoot');
    if (!foot || last <= 1) return;
    var nav = foot.querySelector('.spd-collection__pagination');
    if (!nav) { nav = document.createElement('nav'); nav.className = 'spd-collection__pagination'; nav.setAttribute('aria-label', 'Pagination'); foot.appendChild(nav); }
    var arrowL = '<svg viewBox="0 0 16 16" width="14" height="14" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="m10 3-5 5 5 5"/></svg>';
    var arrowR = '<svg viewBox="0 0 16 16" width="14" height="14" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="m6 3 5 5-5 5"/></svg>';
    var link = function (v, inner, extra, label) { return '<a class="spd-collection__page' + (extra || '') + '" href="' + virtualPageUrl(v) + '"' + (label ? ' aria-label="' + label + '"' : '') + '>' + inner + '</a>'; };
    var off = function (inner) { return '<span class="spd-collection__page spd-collection__page--wide spd-collection__page--off" aria-disabled="true">' + inner + '</span>'; };
    var parts = [];
    parts.push(current > 1 ? link(current - 1, arrowL + '<span class="spd-collection__page-word">Prev</span>', ' spd-collection__page--wide', 'Previous page') : off(arrowL + '<span class="spd-collection__page-word">Prev</span>'));
    var prevV = 0;
    for (var v = 1; v <= last; v++) {
      if (v !== 1 && v !== last && Math.abs(v - current) > 1) continue;
      if (prevV && v - prevV > 1) parts.push('<button type="button" class="spd-collection__page spd-collection__page--gap" data-spd-jump aria-label="Go to a page number"><span aria-hidden="true">\u2026</span></button>');
      parts.push(v === current ? '<span class="spd-collection__page spd-collection__page--now" aria-current="page">' + v + '</span>' : link(v, String(v)));
      prevV = v;
    }
    parts.push(current < last ? link(current + 1, '<span class="spd-collection__page-word">Next</span>' + arrowR, ' spd-collection__page--wide', 'Next page') : off('<span class="spd-collection__page-word">Next</span>' + arrowR));
    nav.innerHTML = parts.join('');
    nav.querySelectorAll('[data-spd-jump]').forEach(function (btn) { if (typeof bindJump === 'function') bindJump(btn); });
    };
    render();
  })();
  // The ellipsis in the pagination turns into a page number box.
  var bindJump;
  (function () {
    var grid = root.querySelector('[data-spd-products]');
    bindJump = function (btn) {
      if (btn.hasAttribute('data-spd-jump-bound')) return;
      btn.setAttribute('data-spd-jump-bound', '');
      var totalPages = virtualLast || (grid ? parseInt(grid.getAttribute('data-spd-pages'), 10) || 0 : 0);
      btn.addEventListener('click', function () {
        var input = document.createElement('input');
        input.type = 'number'; input.min = '1'; input.inputMode = 'numeric'; input.placeholder = 'Page';
        if (totalPages) input.max = String(totalPages);
        input.className = 'spd-collection__page-jump';
        input.setAttribute('aria-label', 'Page number');
        btn.replaceWith(input);
        input.focus();
        var back = function (refocus) { if (input.parentNode) { input.replaceWith(btn); if (refocus) btn.focus(); } };
        input.addEventListener('keydown', function (e) {
          if (e.key === 'Escape') { back(true); return; }
          if (e.key !== 'Enter') return;
          e.preventDefault();
          var n = parseInt(input.value, 10);
          if (!n || n < 1 || (totalPages && n > totalPages)) { input.classList.add('is-bad'); return; }
          if (virtualPageUrl) { location.href = virtualPageUrl(n); return; }
          var u = new URL(location.href);
          u.searchParams.set('page', String(n));
          location.href = u.toString();
        });
        input.addEventListener('blur', function () { setTimeout(function () { back(false); }, 150); });
      });
    };
    root.querySelectorAll('[data-spd-jump]').forEach(bindJump);
  })();
  // Phone strip: mirrors the toolbar's Filters button and sort, visible only while the toolbar is off screen.
  (function () {
    var bar = root.querySelector('[data-spd-stickybar]');
    var toolbar = root.querySelector('.spd-collection__toolbar');
    var toggle = root.querySelector('[data-spd-filters-toggle]');
    if (!bar || !toolbar || !toggle) return;
    var btn = bar.querySelector('[data-spd-stickybar-filters]');
    var label = bar.querySelector('[data-spd-stickybar-label]');
    var mirror = bar.querySelector('[data-spd-stickybar-sort]');
    var narrowQ = window.matchMedia('(max-width: 989px)');
    if (label) label.textContent = toggle.textContent.replace(/\s+/g, ' ').trim();
    if (mirror && sort) {
      mirror.innerHTML = sort.innerHTML;
      mirror.value = sort.value;
      sortSelect(mirror, function (value) { sort.value = value; goSort(value); });
    }
    btn.addEventListener('click', function () { toggle.click(); });
    new MutationObserver(function () { btn.setAttribute('aria-expanded', toggle.getAttribute('aria-expanded') || 'false'); }).observe(toggle, { attributes: true, attributeFilter: ['aria-expanded'] });
    var show = function (on) { bar.hidden = !on; };
    var check = function () {
      if (!narrowQ.matches) { show(false); return; }
      var headerH = parseFloat(getComputedStyle(document.documentElement).getPropertyValue('--spd-header-h')) || 0;
      var r = toolbar.getBoundingClientRect();
      var pastFooter = root.getBoundingClientRect().bottom < headerH + 120;
      show(r.bottom < headerH && !pastFooter);
    };
    if ('IntersectionObserver' in window) new IntersectionObserver(check, { threshold: 0 }).observe(toolbar);
    window.addEventListener('scroll', check, { passive: true });
    window.addEventListener('resize', check);
    check();
  })();
  var views = root.querySelectorAll('[data-spd-view]');
  function setView(mode, push) {
    if (!products) return;
    products.classList.toggle('spd-collection__products--grid', mode === 'grid');
    products.classList.toggle('spd-collection__products--list', mode === 'list');
    views.forEach(function (b) { b.setAttribute('aria-pressed', String(b.dataset.spdView === mode)); });
    if (push) {
      var url = new URL(window.location.href);
      url.searchParams.set('display', mode);
      history.replaceState(null, '', url.toString());
      try { localStorage.setItem('spd_view', mode); } catch (e) {}
    }
  }
  views.forEach(function (b) {
    b.addEventListener('click', function () { setView(b.dataset.spdView, true); });
  });
  // The URL says which view a shared link opens in; otherwise the shopper's last choice sticks.
  var initial = new URL(window.location.href).searchParams.get('display');
  if (!initial) { try { initial = localStorage.getItem('spd_view'); } catch (e) {} }
  if (initial === 'list') setView('list', false);
})();
